<template>
    <div>
        <modal v-if="!showTour" id="changeLogModal" v-model="showChangeLogModal"
               :title="trans('general.changelog.new_update_release') + ': ' + latestVersion">
            <slot v-if="changeLog">
                <a :href="getChangeLogUrl()" target="_blank" v-html="description"></a>
            </slot>
            <template v-slot:footer>
                <a :href="'https://kidsday.io/' + currentLocale + '/changelog'" target="_blank" class="mt-1">
                    {{ trans('general.changelog.view_all_releases') }} ->
                </a>
            </template>
        </modal>
    </div>
</template>

<script>
import Modal from "./Modal";
import axios from "axios";
import { eventBus } from '../../services/EventBus';
import {getCookie, setCookie} from "../../services/CookiesManager";
import {mapLangToLocale} from "../../services/LocaleServices";

export default {
    name: "ChangeLog",
    components: {Modal},
    data() {
        return {
            showChangeLogModal: false,
            currentLocale: 'en',
            description: '',
            latestVersion: '',
            showTour: false,
            changeLog: null,
        };
    },
    created() {
        eventBus.$on('show-tour', (showTour) => {
            this.showTour = showTour;
        });
    },
    methods: {
        mapLangToLocale,
        setCookie, getCookie,
        checkChangeLogVersion() {
            let changelog_checked_today = this.getCookie("changelog_checked_today");

            if (changelog_checked_today === null) {
                axios.get('/changelog/read').then(response => {
                    let changeLog = response.data.data;
                    let version = 'latest';

                    if(changeLog !== null) {
                        this.changeLog = changeLog;
                        let changeLogTranslation = changeLog.translations[0];

                        version = this.latestVersion = changeLog.version;
                        this.currentLocale = mapLangToLocale(changeLogTranslation.locale);
                        this.description = this.formatDescription(changeLogTranslation.description);
                        this.showChangeLogModal = true;
                    }

                    this.setCookie("changelog_checked_today", version, 1);
                });
            }
        },
        formatDescription(desc) {
            let format = desc.replace(/\[new\]/g, '<span class="badge bg-green">NEW</span>');
            format = format.replace(/\[fix\]/g, '<span class="badge bg-blue">FIX</span>');
            format = format.replace(/\[soon\]/g, '<span class="badge bg-orange">SOON</span>');
            format = format.replace(/\[removed\]/g, '<span class="badge bg-red">REMOVED</span>');
            return format;
        },
        getChangeLogUrl() {
            return appConfig.landingUrl + '/' + this.currentLocale + '/changelog/update/' + this.changeLog.remote_id;
        }
    },
    mounted() {
        this.checkChangeLogVersion();
    }
};
</script>

<style>
#changeLogModal a {
    color: unset !important;
}

#changeLogModal .modal-body p {
    display: flex;
}

#changeLogModal .modal-body .badge {
    margin-right: 10px;
    height: 20px;
    min-width: 50px;
}

#changeLogModal img {
    max-width: 100%;
    border-radius: 15px;
}
</style>
